import styled from "styled-components";

export const DownloadsTableContainer = styled.div`
      .inputData_table_searchable .css-1tbggly {
        background-color: #33383c !important;
        border: 1px solid #f5f5f54d !important;
        min-height: 4.5rem;
      }
      .inputData_table_searchable
        .css-78trlr-MuiButtonBase-root-MuiIconButton-root {
        color: #fff;
      }
      .inputData_table_searchable tbody tr.MuiTableRow-root {
        background-color: #33383c !important;
      }
      .inputData_table_searchable .css-10gei56 {
        background-color: #33383c !important;
        min-height: 4.5rem;
      }
      .inputData_table_searchable {
        border: 1px solid #f5f5f54d !important;
        border-radius: 8px;
      }
      .inputData_table_searchable .css-1atu56z-MuiPaper-root {
        color: #fff;
      }
      .inputData_table_searchable .MuiTablePagination-root .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-animated.MuiFormLabel-colorPrimary.MuiInputLabel-root.MuiInputLabel-animated {
        color: #fff;
        font-size: 15px;
      }
      .inputData_table_searchable
        .css-1mmm5cp-MuiInputBase-root-MuiInput-root-MuiSelect-root {
        color: #fff;
        font-size: 15px;
      }
      .inputData_table_searchable .css-pqjvzy-MuiSvgIcon-root-MuiSelect-icon {
        color: #fff !important;
        font-size: 15px;
      }
      .inputData_table_searchable
        .css-1pe4mpk-MuiButtonBase-root-MuiIconButton-root.Mui-disabled {
        background-color: transparent;
        color: #fff;
      }
      .inputData_table_searchable
        .css-1v8abvc-MuiInputBase-root-MuiOutlinedInput-root {
        color: #fff;
      }
      .inputData_table_searchable
        .MuiCollapse-wrapper.MuiCollapse-horizontal.css-18w3a48-MuiCollapse-wrapper {
        border: 1px solid #f5f5f54d !important;
        display: block !important;
        border-radius: 5px;
      }
      .inputData_table_searchable .MuiTableCell-head svg[data-testid="SyncAltIcon"] {
        color: #fff !important;
      }
      .inputData_table_searchable
        .Mui-TableHeadCell-Content-Actions.MuiBox-root.css-epvm6 {
        display: none !important;
      }
      // .inputData_table_searchable .css-i4bv87-MuiSvgIcon-root {
      //   font-size: 20px;
      // }
      .inputData_table_searchable .css-8k4lth {
        padding: 8px;
      }
      // .inputData_table_searchable .css-1f2oslk-MuiTypography-root {
      //   font-size: 15px;
      // }
      .inputData_table_searchable
        .MuiSvgIcon-root[data-testid="CloseIcon"]  {
        font-size: 20px;
      }
      .inputData_table_searchable
        .MuiIconButton-root[aria-label="Clear search"] {
        color: rgb(196 192 192 / 54%);
      }
      .inputData_table_searchable
        .MuiIconButton-root[aria-label="Toggle full screen"] {
        display: none;
      }
      .inputData_table_searchable .MuiIconButton-root[aria-label="Toggle density"] {
        display: none;
      }
      .inputData_table_searchable
        .MuiIconButton-root[aria-label="Show/Hide columns"] {
        display: none;
      }
      .inputData_table_searchable
        .MuiIconButton-root[aria-label="Show/Hide filters"] {
        display: none;
      }
      .inputData_table_searchable th:last-child .MuiTableSortLabel-icon {
        display: none !important;
      }
      .inputData_table_searchable th:last-child .Mui-TableHeadCell-Content-Labels{
        cursor: auto !important;
      }
      .inputData_table_searchable .css-nhjqqh-MuiTableContainer-root {
        max-height: 600px;
      }
      .inputData_table_searchable .css-1j43wpm-MuiButtonBase-root-MuiTableSortLabel-root .MuiTableSortLabel-icon{
        color: #ffffff !important;
      }
      .inputData_table_searchable
        .MuiCollapse-root.MuiCollapse-horizontal.MuiCollapse-entered.css-1d98dbz-MuiCollapse-root {
        display: block !important;
      }
      .inputData_table_searchable
        .css-12yjm75-MuiInputBase-input-MuiOutlinedInput-input::placeholder {
        color: #fff !important;
      }
      .inputData_table_searchable {
        margin-top: 20px;
      }
      .inputData_table_searchable th {
        border-color: #f5f5f54d;
        background-color: #33383ccc;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        padding: 10px 10px;
        border-right: 1px solid #f5f5f54d;
      }
      .inputData_table_searchable td {
        border-color: #f5f5f54d;
        font-size: 12px;
        padding: 12px 10px;
        border-right: 1px solid #f5f5f54d;
        color: #fff;
      }
    
      .info-icon-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #fff;
        cursor: pointer;
    }
    
    .info-icon-container span {
        color: #000;
    }
    .inputData_table_searchable td:last-child span{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .inputData_table_searchable td:first-child{
        text-align:center;
    }
    .inputData_table_searchable .css-zrlv9q , .inputData_table_searchable .css-wsew38{
        justify-content: center;
    }
    .inputData_table_searchable .css-14vyde3-MuiCollapse-wrapperInner{
        width:450px;
    }
    .inputData_table_searchable .css-11sh9fj-MuiFormControl-root-MuiTextField-root ,.inputData_table_searchable  .css-1u3bzj6-MuiFormControl-root-MuiTextField-root {
        width:450px;
    }
    .inputData_table_searchable .css-euw4nl-MuiTableRow-root{
        background-color: #33383c !important;
    }
    .inputData_table_searchable .css-1ezkbdg-MuiButtonBase-root-MuiRadio-root{
        color: #fff !important;
    }
    .inputData_table_searchable .css-1ezkbdg-MuiButtonBase-root-MuiRadio-root.Mui-checked {
        color: #fff !important;
    }
    .inputData_table_searchable .css-1yq237c-MuiTableRow-root.Mui-selected {
        background-color: rgb(0 122 122) !important;
    }
    .inputData_table_searchable  .css-1yq237c-MuiTableRow-root td:after{
        background-color: transparent;
    }
    .inputData_table_searchable .selected-row {
        background-color: #e6f7ff; // Light blue as an example
    }
    .dataIndex_table button[area-label="Clear search"]{
      color: #ffffff;
    }
    .dataIndex_table button.Mui-disabled[area-label="Clear search"]{
      color: rgb(196 192 192 / 54%);
    }
     .inputData_table_searchable .MuiTablePagination-root button.Mui-disabled[aria-label="Go to first page"],
    .inputData_table_searchable .MuiTablePagination-root button.Mui-disabled[aria-label="Go to previous page"],
    .inputData_table_searchable .MuiTablePagination-root button.Mui-disabled[aria-label="Go to next page"],
    .inputData_table_searchable .MuiTablePagination-root button.Mui-disabled[aria-label="Go to last page"] {
        color: rgba(255, 255, 255, 0.2) !important;
        border-radius: 6px;
        padding: 3px 3px;
    }

    .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to first page"],
    .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to previous page"],
    .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to next page"],
    .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to last page"] {
        color: #36BDBE !important;
        border-radius: 6px;
        padding: 3px 3px;
    }

    .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to first page"] svg,
    .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to previous page"] svg,
    .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to next page"] svg,
    .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to last page"] svg {
        font-size: 27px !important;
    }
    .inputData_table_searchable .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation2 .MuiTablePagination-root .MuiTypography-root.MuiTypography-body2.MuiTypography-alignCenter{
      font-size: 14px;
      color: #ffffff !important;
    }

    .inputData_table_searchable .MuiTablePagination-root .MuiInputBase-root.MuiInput-root.MuiInputBase-colorPrimary{
      color: rgb(54, 189, 190) !important;
      font-size: 14px;
    }

    .inputData_table_searchable .MuiTablePagination-root .MuiInputBase-root.MuiInput-root.MuiInputBase-colorPrimary svg{
        color: rgb(54, 189, 190) !important;
        font-size: 22px;
    }

    .inputData_table_searchable .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation2 .MuiTablePagination-root .MuiTypography-root.MuiTypography-body2.MuiTypography-alignCenter{
      font-size: 14px;
    }



    .inputData_table_searchable .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.MuiInputBase-adornedStart.MuiInputBase-adornedEnd {
      color: rgb(255, 255, 255);
      padding: 0px 10px;
      background: rgba(255, 255, 255, 0.24);
    }
    .inputData_table_searchable .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.MuiInputBase-adornedStart.MuiInputBase-adornedEnd input {
      padding: 3px 0px !important;
      font-size: 14px !important;
      color: rgb(255, 255, 255) !important;
    }
    .inputData_table_searchable .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.MuiInputBase-adornedStart.MuiInputBase-adornedEnd fieldset {
        border: none !important;
    }
    .inputData_table_searchable svg[data-testid="SearchIcon"] {
        font-size: 20px;
    }
    .inputData_table_searchable .MuiFormControl-root.MuiTextField-root
        width: 250px;
    }
    
    @media only screen and (max-width: 600px) {
        .inputData_table_searchable .css-14vyde3-MuiCollapse-wrapperInner {
            width: 150px; 
        }
    
        .inputData_table_searchable .css-11sh9fj-MuiFormControl-root-MuiTextField-root, .inputData_table_searchable .css-1u3bzj6-MuiFormControl-root-MuiTextField-root {
            width: 150px;
        }
    }

    .download_table_block td:first-child{
        text-align: left !important;
    }
    .download_table_block .MuiTableRow-root.Mui-selected{
        background-color: #33383ccc !important;
        opacity: 0.8;
    }
    .download_table_block .MuiTableRow-root.Mui-selected td:after{
        background-color: #33383ccc !important;
    }
    .download_table_block table tr .MuiButtonBase-root.MuiCheckbox-root{
      color: #007a7a !important;
    }
    .download_table_block table tr .MuiButtonBase-root.MuiCheckbox-root.Mui-checked{
      color: #007a7a !important;
    }
    .download_table_block table td:first-child, .download_table_block table th:first-child{
      text-align:center !important;
    }  
    .download_table_block table th:first-child .css-1w86f15{
      justify-content: center !important;
    } 
`;
